import { UUID } from '@finxone-platform/shared/base-types';
import {
  APP_ZONES,
  Columns,
  Constants,
  InputCssConfig,
  InputFieldSettings,
  ListActionValue,
  ViewType,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
  defaultTableListingConfig,
} from '@finxone-platform/shared/sys-config-types';
import { inputSettings } from './payments.type';

export const recurringPaymentListItemTemplate = `
<div class="p-4 main-bg-color rad-1 w-full mb-3">
  <div class="flex items-center justify-content-between gap-2">
    <div class="flex-1 overflow-hidden">
      <div class="body2 textOnSurface">{{ currencyPipe recurringPayment.amount currencyCode=recurringPayment.currency }}</div>
      <div class="labelText textOnSurfaceMuted mt-1">{{ datePipe recurringPayment.nextCollectionDate format='d-MM-yyyy' }}</div>
    </div>
    <span id="view-detail" class="labelText textOnSurfaceMuted cursor-pointer">View</span>
  </div>
</div>
`;

export const recurringPaymentFetchingTemplate = 'Fetching recurring payments...';

export const recurringPaymentNoRecordsTemplate = 'No recurring payments found';

export const recurringPaymentColumnListing: Columns[] = [
  {
    label: 'Frequency',
    value: 'frequency',
    handleBarKey: '<span class="text-capitalize">{{ frequency }}</span>',
    selected: true,
  },
  {
    label: 'Amount',
    value: 'amount',
    handleBarKey: '{{ currencyPipe amount currencyCode=currency }}',
    selected: true,
  },
  {
    label: 'Collection Day',
    value: 'collectionDay',
    handleBarKey: '{{ collectionDay }}',
    selected: true,
  },
  {
    label: 'Next Collection',
    value: 'nextCollectionDate',
    handleBarKey: `{{ datePipe nextCollectionDate format='d-MM-yyyy'}}`,
    selected: true,
  },
  {
    label: 'Status',
    value: 'status',
    handleBarKey: '<span class="text-capitalize">{{ status }}</span>',
    selected: true,
  },
  {
    label: '',
    value: 'more-option',
    // `actionEnabled` is set per row by the widget: false once the row has no menu option left to
    // offer, so the ellipsis goes with it instead of opening an empty menu.
    handleBarKey: `{{#if actionEnabled}}<div id="more-options">{{{ svgIcon 'more-options-eclipse' '32px' '32px' }}}</div>{{/if}}`,
    selected: true,
  },
];

export const recurringPaymentListWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.VARIABLE_RECURRING_PAYMENT_LIST_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.VARIABLE_RECURRING_PAYMENT_LIST_WIDGET,
    widgetConfigDisplayName: WidgetTitles.VARIABLE_RECURRING_PAYMENT_LIST_WIDGET,
    attributes: {
      elementsConfig: [],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        backGroundColor: 'var(--color-surface)',
        borderWidth: 1,
        borderColor: 'var(--color-border-color)',
        borderStyle: 'solid',
      },
      widgetProperties: {
        textContent: recurringPaymentListItemTemplate,
        appBuilderState: '',
        menuOptions: [
          {
            label: 'Cancel',
            value: ListActionValue.CANCEL,
            isIdNotExist: '',
            zoneToNavigate: APP_ZONES.PAYMENT,
            urlToNavigate: '',
          },
        ],
        icon: 'search',
        inputFieldSettings: {
          ...inputSettings,
          css_config: {
            inputWidth: 25,
            iconSize: 24,
            iconSizeUnit: 'px',
            inputPosition: 'end',
          } as InputCssConfig,
          label: 'Search',
          type: 'search',
          isIconAllowed: true,
          isAllowed: false,
        } as InputFieldSettings,
        gestures: {
          panEnabled: false,
        },
      },
      ...defaultTableListingConfig,
      fetchingTemplate: recurringPaymentFetchingTemplate,
      noRecordsTemplate: recurringPaymentNoRecordsTemplate,
      viewType: ViewType.LIST,
      columns: recurringPaymentColumnListing,
      pageSize: 10,
      pagingEnabled: true,
    },
    isRemovable: true,
  },
  gridPosition: {
    dragEnabled: true,
    resizeEnabled: true,
    x: 0,
    y: 3,
    rows: 25,
    cols: 15,
  },
  widgetIconPath: 'listing',
};
